<template>
    <div class="solgan">
        <slot />
    </div>
</template>


<script setup>

</script>

<style lang="postcss">
.solgan {
    @apply text-[20px] font-bold tracking-[1px] leading-[28.96px] py-[20px];
    @apply tablet: (pt-[56px] pb-[32px] text-[48px] leading-[69.5px] tracking-[2px]);
}
</style>